import { render, staticRenderFns } from "./mySales.vue?vue&type=template&id=7081f462&scoped=true&lang=html&"
import script from "./mySales.vue?vue&type=script&lang=js&"
export * from "./mySales.vue?vue&type=script&lang=js&"
import style0 from "./mySales.vue?vue&type=style&index=0&id=7081f462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7081f462",
  null
  
)

export default component.exports